import { gql } from "@apollo/client"

export const PACKING_ALLOTMENT_FRAG = gql`
  fragment packingallotmentSet on PackingAllotmentSelectorType {
    id
    allotedQuantity
    allotedWeight
    sendToLine
    productionLine {
      id
      name
    }
    createdAt
    updatedAt
    reverseWeight
    reversalReason
    reverseQuantity
    supervisor {
      id
      fullName
    }
  }
`
